import React from 'react';

// components
import Modal from 'react-bootstrap/Modal';

// styles
import ModalStyles from "../../DashboardReuseAbleComponents/Modal.module.css";
import styles from "./SelectFacilitiesModal.module.css";


const SelectFacilitiesModal = (props) => {
    const titles = props?.facilitiData?.filter((item) => item.parentId === null);
    
    console.log(titles);

    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
            </style>

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'>
                    <div className='w-100 d-flex align-items-start justify-content-between px-3'>
                        <div className={ModalStyles.title}>
                            افزودن امکانات
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex flex-column align-items-center justify-content-center position-relative'>
                        {titles?.map((item) => (
                            <div key={item.id} id="container" className='w-100 d-flex flex-column align-items-center justify-content-center my-3 bg-light rounded'>
                                <div className={`w-100 text-center mt-3 mb-2 ${ModalStyles.text_black_sm}`}>
                                    {item.title}
                                </div>
                                <div className='w-100 d-flex flex-wrap align-items-center justify-content-around my-2 px-2'>
                                    {props?.facilitiData?.filter((buttons) => buttons.parentId === item.id).map((button) => (
                                        <button key={button.id} id={button.title} className={`d-flex align-items-center justify-content-center pointer ${props.addedFacilitiesID?.includes(button.id) ? styles.button_selected : styles.button_on_selected}`} onClick={props.addedFacilities.includes(button.title) ? () => removeItem(button.title, button.id) : () => handleClick(button.title, button.id)}>
                                            {button.title}
                                        </button>
                                    ))}
                                </div>
                                {item.title === "نوع و تعداد پارکینگ" &&
                                    <div className='w-100 my-2 d-flex align-items-center justify-content-between px-3'>
                                        <div className={`w-50 d-flex align-items-center justify-content-between px-3 ${styles.counter_container}`}>
                                            <button className={`text-start ${styles.count_btn}`} onClick={countDownHandler}>
                                                -
                                            </button>
                                            <div className={styles.count}>
                                                {props.parkingCount?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
                                                }
                                            </div>
                                            <button className={`text-end ${styles.count_btn}`} onClick={addCountHandler}>
                                                +
                                            </button>
                                        </div>
                                        <div className={styles.title_primary}>
                                            تعداد پارکینگ
                                        </div>
                                    </div>
                                }
                            </div>
                        ))}
                        <div className={`w-100 d-flex justify-content-center align-items-center mb-3 ${styles.btn_submit_container}`}>
                            <div className={`w-100 d-flex align-items-center justify-content-center ${ModalStyles.filled_btn}`} onClick={props.onHide}>
                                ثبت
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );

    function countDownHandler() {
        if (props.parkingCount >= 1) {
            props.setParkingCount((prev) => {
                return prev - 1;
            });
        }
    }

    function addCountHandler() {
        props.setParkingCount((prev) => {
            return prev + 1;
        });
    }



    // function handleClick(title, id) {
    function handleClick(title, id) {
        props.setAddedFacilities(current => [...current, title]);
        props.setAddedFacilitiesID(current => [...current, id]);
    }

    // }

    function removeItem(buttonTitle, buttonID) {
        props.setAddedFacilities((current) =>
            current.filter((element) => {
                return element !== buttonTitle;
            })
        );
        props.setAddedFacilitiesID((current) =>
            current.filter((element) => {
                return element !== buttonID;
            })
        );
    }

}

export default React.memo(SelectFacilitiesModal);
